/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Schedule type
 */
export type InstructionQuoteRequestAttributesScheduleType = typeof InstructionQuoteRequestAttributesScheduleType[keyof typeof InstructionQuoteRequestAttributesScheduleType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InstructionQuoteRequestAttributesScheduleType = {
  FUTURE: 'FUTURE',
  RECURRING: 'RECURRING',
} as const;
